<div class="div-27 mb-3">{{reportPlaceHolders['LBL_Deal_Report']}}</div>





<div class="merchant-details-card">
  <img *ngIf="brandlogo" [src]="brandlogo" alt="Preview" class="merchant-logo" style="max-width: 150px; height: auto;">
  <div class="merchant-info">
    <p><strong>{{reportPlaceHolders['LBL_MERCHANT']}}:</strong> {{userData.marketplace_name}}</p>
    <p><strong>{{reportPlaceHolders['LBL_ADDRESS']}}:</strong> {{userData.addressLine1}},{{userData.city_name}}, {{userData.country_name}}</p>
    <p><strong>{{reportPlaceHolders['LBL_CONTACT']}}:</strong> +{{userData.phone_country_code}}{{userData.business_contact_number}}</p>
    <P><strong>{{reportPlaceHolders['LBL_AVAILABLE_FROM']}}:</strong>{{merchantDate}}</P>
    <P><strong>Mobile:</strong>+{{profiledata.mobile_country_code + profiledata.mobile}}</P>
  </div>

  <button class="export-btn" (click)="generatePDF()">{{reportPlaceHolders['LBL_lower_Deals_Claimed']}}</button>
  <button style="margin-left: 5px;" class="export-btn" (click)="goBack()">{{reportPlaceHolders['LBL_lower_Favourites']}}</button>
</div>

<div class="summary-container">
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_DEALS']}}:</strong> {{ reportTotalDeals }}</span>
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_BUDGET']}}:</strong> {{ reportTotalBudget }}</span>
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_SPENT']}}:</strong> {{ reportTotalSpent }}</span>
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_CHARGED']}}:</strong> {{ reportSpendCharged }}</span>
</div>
<hr />

<form [formGroup]="dashboardForm">

  <div class="div-26">
    <div class="filter-container pt-2">
      <label for="statusFilter">Status:</label>
      <select style="width: 25%;" class="form-control" id="statusFilter" [ngModelOptions]="{standalone: true}"
        [(ngModel)]="selectedStatus">
        <option value="">All</option>
        <!-- <option value="P">Pending</option>
        <option value="D">Draft</option> -->
        <option value="C">Completed</option>
        <option value="A">Active</option>
        <option value="E">Expired</option>
      </select>

      <label style="width: 10%;" for="dateFilter">{{reportPlaceHolders['LBL_DATE_FROM']}}:</label>
      <input class="form-control" style="width: 25%;" type="date" id="dateFilter" [ngModelOptions]="{standalone: true}"
        [(ngModel)]="dateFrom">

      <label style="width: 7%;" for="dateToFilter">{{reportPlaceHolders['LBL_DATE_TO']}}:</label>
      <input class="form-control" style="width: 25%;" type="date" id="dateToFilter"
        [ngModelOptions]="{standalone: true}" [(ngModel)]="dateTo">

      <button style="width: 14%;" (click)="customOkClick()">{{reportPlaceHolders['LBL_APPLY_FILTERS']}}</button>
      <button (click)="resetFilters()">{{reportPlaceHolders['LBL_RESET']}}</button>
    </div>


    <div class="table-container">
      <table class="styled-table">
        <thead>
          <tr>
            <th>UUID</th>
            <th>Image</th>
            <th>{{reportPlaceHolders['TBL_NAME']}}</th>
            <th>{{reportPlaceHolders['TBL_STATUS']}}</th>
            <th>{{reportPlaceHolders['TBL_BUDGET']}}</th>
            <th>{{reportPlaceHolders['TBL_TOTAL_SPENT']}}</th>
            <th>{{reportPlaceHolders['TBL_CHARGED']}}</th>
            <th>{{reportPlaceHolders['TBL_CREATED_DATE']}}</th>
            <th>{{reportPlaceHolders['TBL_AVAILABLE_FROM']}}</th>
            <th>{{reportPlaceHolders['TBL_AVAILABLE_TO']}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let deal of paginatedDeals">
            <td>{{ deal.uuid }}</td>
            <td><img [src]="getFullImageUrl(deal.product_image)" alt="Image preview" class="product-img" />
            </td>
            <td>{{ deal.product_name }}</td>
            <td>
              <mat-chip [ngClass]="getStatusClass(deal.status)">
                {{ getStatusLabel(deal.status) }}
              </mat-chip>
            </td>
            <td>{{ deal.budget }}</td>
            <td>{{ deal.total_spent }}</td>
            <td>{{ deal.spentAlreadyCharged }}</td>
            <td>{{ deal.created_date }}</td>
            <td>{{ deal.available_from }}</td>
            <td>{{ deal.available_to }}</td>
            <!-- <td>
              <button (click)="viewDetails(deal)">View Details</button> 
            </td> -->
          </tr>
        </tbody>
      </table>
      <!-- <div class="pagination">
        <button (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
      </div> -->
    </div>

    <!-- <div class="div-56">
      <div class="div-57 pt-3">{{placeHolders['LBL_ALL_DEALS']}}</div>

      <div class="div-55" *ngIf="data.length!==0">

        <ag-grid-angular style="width: 100%; " class="ag-theme-quartz" [rowData]="data" domLayout='autoHeight'
          [gridOptions]="gridOptions" [suppressDragLeaveHidesColumns]="true" [columnDefs]="columnDefs"
          [animateRows]="true" [pagination]="false" (gridReady)="onGridReady($event)">
        </ag-grid-angular>


      </div>



      <div *ngIf="isNewUser; else noRecords">

        <div class="div-Norecord" *ngIf="data.length===0">
          <div class="div-Norecord2">
            <div class="div-Norecord3">No Record Found !!</div>
          </div>
        </div>
      </div>
      <ng-template #noRecords>
        <div class="div-Norecord" *ngIf="data.length===0">
          <div>
            <img style="height: 120px; width: 120px;" src="../../../assets/images/createcampaign.png">
            <div class="div-Norecord3" [ngClass]="createrecordtext()">{{placeHolders['LBL_NO_DEALS_CREATED']}}</div>
            <div class="div-centerlabel firsttimeRecord">
              <div class="div-createdeal" (click)="createCampaign()">{{placeHolders['LBL_CREATE_DEAL']}}</div>
              <img loading="lazy" [ngClass]="getDynamicClass()"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/1a173d72-6ffb-4055-8028-ba2b294272a4?"
                class="img-13" />
            </div>
          </div>
        </div>

      </ng-template>

      <div class="row mt-2">
        <div class="col-lg-12 col-md-12 ml-auto mr-auto">
          <div class="float-right">
            <app-pagination *ngIf="recordTotalCount!==0" [totalRecords]="recordTotalCount" [recordsPerPage]="10"
              [activePage]="activePage" (onPageChange)="displayActivePage($event)"></app-pagination>
          </div>
        </div>
      </div>



    </div> -->

    <div class="row mt-2">
      <div class="col-lg-12 col-md-12 ml-auto mr-auto">
        <div style="display: flex; justify-content: center;">
          <!-- <div>
            <button (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
            <span>Page {{ currentPage }} of {{ totalPages }}</span>
            <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
          </div> -->
          <div style="display: flex; align-items: center; justify-content: center; gap: 16px;">
            <button (click)="previousPage()" [disabled]="currentPage === 1" style="font-size: 20px;padding: 0px 5px;">
              &#8592;
            </button>
          
            <div style="padding: 8px 16px; background-color: #ffffff; border-radius: 8px;">
              Page {{ currentPage }} of {{ totalPages }}
            </div>
          
            <button (click)="nextPage()" [disabled]="currentPage === totalPages" style="font-size: 20px;padding: 0px 5px;">
              &#8594;
            </button>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</form>